import { useCookies } from 'next-client-cookies';
import { formattedPickupDateFromUTC } from "helpers/estimatedPickupDatehelper";
import { applyMask, getPhoneMask } from 'components/commercetools-ui/molecules/address-form/utils';

interface Props {
    pickUpAtRetailAddress?: string;
    channelName?: string;
    orderDetailsData?: any;
    earliestPickUpText?: string;
}

const P2RFulfillment: React.FC<Props> = ({
    pickUpAtRetailAddress,
    channelName,
    orderDetailsData,
    earliestPickUpText,
}) => {
    const cookies = useCookies();
    const locale = cookies.get('locale') as string;

    const channelNameCaps = channelName?.toUpperCase() == 'CVS' ? channelName?.toUpperCase() : channelName;
    const storePhone = orderDetailsData?.shippingAddress?.phone;
    const countryCode = orderDetailsData?.shippingAddress?.country ?? 'US';
    const displayStorePhone = applyMask(storePhone, getPhoneMask(countryCode)) ?? storePhone;
    return (
        <div
            className="mt-28 flex flex-col rounded-xl border border-[#EBEBEB] bg-white p-20"
            data-ffid="ctr-fulfillment-p2r"
        >
            {/* HEADER */}
            <div className="text-14 font-semibold text-gray-800 lg:text-16" data-ffid="lbl-fulfillment-header">
                {pickUpAtRetailAddress}
            </div>

            {/* CONTENT */}
            <div className="flex flex-col gap-12 lg:flex-row" data-ffid="ctr-fulfillment-content">
                {/* STORE ADDRESS */}
                <div className="flex-1" data-ffid="ctr-fulfillment-store">
                    <div className="text-14 font-normal text-gray-800 lg:text-16" data-ffid="lbl-fulfillment-store-name">
                        {channelNameCaps}
                    </div>
                    <div className="text-14 text-gray-700 lg:text-16" data-ffid="lbl-fulfillment-store-street">
                        {orderDetailsData?.shippingAddress?.streetName} {orderDetailsData?.shippingAddress?.additionalStreetInfo}
                    </div>
                    <div className="text-14 text-gray-700 lg:text-16" data-ffid="lbl-fulfillment-store-city">
                        {`${orderDetailsData?.shippingAddress?.city}, ${orderDetailsData?.shippingAddress?.region}, ${orderDetailsData?.shippingAddress?.postalCode}`}
                    </div>
                    <div className="text-14 text-gray-700 lg:text-16" data-ffid="lbl-fulfillment-phone">
                        {displayStorePhone || ''}
                    </div>
                </div>

                {/* EARLIEST PICKUP TIME */}
                {orderDetailsData?.pickupdatetime && (
                    <div className="flex-1" data-ffid="ctr-fulfillment-pickup">
                        <div className="mb-4 text-14 text-gray-700 lg:text-16" data-ffid="lbl-fulfillment-pickup-title">
                            {earliestPickUpText}
                        </div>
                        <div className="text-14 lg:text-16" data-ffid="lbl-fulfillment-pickup-value">
                            {formattedPickupDateFromUTC(
                                orderDetailsData?.pickupdatetime,
                                orderDetailsData?.pickupTimeZone,
                                locale
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
};

export default P2RFulfillment